function importAll(r) {
  return r.keys().map(r);
}

export const loadImages = (context) => {
  return importAll(context);
};
